// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(min-height:1600px){.produtos-items-wrap{margin-top:-50px;margin-bottom:-50px;padding-top:50px!important}}.produtos-items .v-image{transition:all .3s}.produtos-items:hover .v-image{transform:scale(1.08)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
